import React from 'react'
import { useSelector } from 'react-redux'
import { LineChart } from 'components/Charts'
import { SALARIES, HEADER } from 'constants/forioVariables'
import { CONSTANTS } from 'constants/constants'

const { SEGMENTO_PURETE_REGION_I } = SALARIES
const { TIME } = HEADER
const { TOTAL_CUSTOMER_POPULAR_SEGMENT } = CONSTANTS

const returnData = (variables, time) => {
  return {
    labels: time ? time[TIME] : [0],
    datasets: [
      {
        label: TOTAL_CUSTOMER_POPULAR_SEGMENT,
        fill: false,
        borderColor: '#4bc0c0',
        data: variables[SEGMENTO_PURETE_REGION_I],
      },
    ],
  }
}

const SegmentoPopular = () => {
  const variables = useSelector(state => state.salaries.currentValues.variablesSalariesCharts)
  const time = useSelector(state => state.header.variablesHeader)
  return time && time[TIME] ? (
    <LineChart
      data={returnData(variables, time)}
      titleColor="#9E8585"
      titleChart={TOTAL_CUSTOMER_POPULAR_SEGMENT}
    />
  ) : null
}
export default SegmentoPopular
